import AgendaContainer from "../containers/AgendaContainer"

export default function AgendaPro() {
  return <AgendaContainer />
}